// extracted by mini-css-extract-plugin
export var addressFields = "_pu-0";
export var animationContainer = "_pu-1";
export var footer = "_pu-2";
export var lineItems = "_pu-3";
export var modalContent = "_pu-4";
export var orderName = "_pu-5";
export var strong = "_pu-6";
export var warning = "_pu-7";